import { authManager } from '../auth-manager.js';
import { escapeHTML } from '../security.js';

export async function renderFamilyView(container, param, syncManager) {
  container.innerHTML = `
    <div style="max-width: 600px; margin: 0 auto; padding-bottom: 2rem;">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1.25rem;">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <a href="#notas" style="display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; background: #ECEAE3; border-radius: 50%; color: #111827; text-decoration: none;">
            <span class="material-symbols-outlined" style="font-size: 20px;">arrow_back</span>
          </a>
          <div>
            <h1 style="font-size: clamp(1.25rem, 4.5vw, 1.6rem); font-weight: 800; color: #111827; margin: 0; line-height: 1.2;">Minha Família</h1>
            <p class="text-muted" style="margin: 0.15rem 0 0 0; font-size: 0.82rem;">Compartilhamento de gastos e listas</p>
          </div>
        </div>
      </div>

      <div id="family-content-container">
        <div class="chart-card text-center" style="padding: 2.5rem 1rem;">
          <span class="material-symbols-outlined spin" style="font-size: 32px; color: #10B981;">progress_activity</span>
          <p class="text-muted" style="margin-top: 0.5rem; font-size: 0.875rem;">Carregando dados da família...</p>
        </div>
      </div>
    </div>
  `;

  const contentEl = container.querySelector('#family-content-container');
  await loadFamilyData(contentEl, syncManager);
}

async function loadFamilyData(contentEl, syncManager) {
  try {
    const res = await authManager.fetchWithAuth('/api/family');

    if (!res.ok) {
      throw new Error('Falha ao carregar grupo familiar');
    }

    const data = await res.json();

    if (!data.hasFamily) {
      renderCreateFamilyCard(contentEl, syncManager);
    } else {
      renderFamilyDetails(contentEl, data.family, syncManager);
    }
  } catch (err) {
    console.error('Family view error:', err);
    contentEl.innerHTML = `
      <div class="chart-card text-center" style="padding: 2rem 1rem; border-color: #FECDD3;">
        <span class="material-symbols-outlined" style="font-size: 36px; color: #EF4444;">error</span>
        <p style="font-weight: 700; color: #111827; margin-top: 0.5rem;">Erro ao carregar dados da família</p>
        <p class="text-muted" style="font-size: 0.875rem;">${escapeHTML(err.message)}</p>
        <button id="btn-retry-family" class="btn btn-secondary" style="margin-top: 0.75rem; border-radius: var(--radius-pill);">
          Tentar Novamente
        </button>
      </div>
    `;
    contentEl.querySelector('#btn-retry-family')?.addEventListener('click', () => loadFamilyData(contentEl, syncManager));
  }
}

function renderCreateFamilyCard(contentEl, syncManager) {
  contentEl.innerHTML = `
    <div class="chart-card" style="padding: 2rem 1.5rem; text-align: center;">
      <div style="width: 64px; height: 64px; background: #ECFDF5; border: 1px solid #A7F3D0; border-radius: 1.25rem; display: flex; align-items: center; justify-content: center; margin: 0 auto 1.25rem auto;">
        <span class="material-symbols-outlined" style="font-size: 32px; color: #047857;">group_add</span>
      </div>

      <h2 style="font-weight: 800; color: #111827; font-size: 1.25rem; margin: 0 0 0.4rem 0;">Compartilhamento Familiar</h2>
      <p class="text-muted" style="font-size: 0.875rem; line-height: 1.5; margin: 0 0 1.5rem 0;">
        Crie um Grupo Familiar para adicionar membros da sua família e acompanhar os gastos consolidados de todos em um só lugar.
      </p>

      <form id="create-family-form" style="display: flex; flex-direction: column; gap: 0.85rem; max-width: 400px; margin: 0 auto;">
        <input type="text" id="family-name-input" placeholder="Ex: Família Pineli" required style="width: 100%; box-sizing: border-box; padding: 0.75rem 1rem; background: #FFFFFF; border: 1px solid var(--color-border); border-radius: 0.75rem; color: #111827; font-size: 0.9rem; outline: none;">
        
        <button type="submit" id="btn-submit-create-family" class="btn btn-primary" style="width: 100%; font-weight: 700; padding: 0.8rem; border-radius: var(--radius-pill); cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 0.4rem; font-size: 0.9rem;">
          <span class="material-symbols-outlined" style="font-size: 18px;">add_circle</span>
          Criar Grupo Familiar
        </button>
      </form>
    </div>
  `;

  const form = contentEl.querySelector('#create-family-form');
  const input = contentEl.querySelector('#family-name-input');
  
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const name = input?.value?.trim();
      if (!name) return;

      try {
        const res = await authManager.fetchWithAuth('/api/family', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ name })
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.error || 'Não foi possível criar o grupo familiar');
        }

        if (syncManager) syncManager.showToast('Grupo familiar criado com sucesso!', 'success');
        await loadFamilyData(contentEl, syncManager);
      } catch (err) {
        if (syncManager) {
          syncManager.showToast(err.message, 'error');
        } else {
          console.error(err);
        }
      }
    });
  }
}

function renderFamilyDetails(contentEl, family, syncManager) {
  const membersHTML = (family.members || []).map(m => {
    const isPending = m.status === 'pending';
    const initials = (m.userName || m.invitedEmail || 'M').substring(0, 2).toUpperCase();
    const displayName = m.userName || m.invitedEmail;
    const avatar = m.userPicture
      ? `<img src="${escapeHTML(m.userPicture)}" alt="" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;" referrerpolicy="no-referrer" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"><span style="display: none; width: 100%; height: 100%; align-items: center; justify-content: center; font-weight: 800;">${initials}</span>`
      : `<span>${initials}</span>`;

    return `
      <div style="display: flex; align-items: center; justify-content: space-between; padding: 0.95rem 1.1rem; background: #F8FAFC; border: 1px solid var(--border-color); border-radius: 1rem;">
        <div style="display: flex; align-items: center; gap: 0.85rem; min-width: 0; flex: 1;">
          <div style="width: 44px; height: 44px; border-radius: 50%; background: #E2E8F0; color: #111827; font-weight: 800; display: flex; align-items: center; justify-content: center; overflow: hidden; flex-shrink: 0; font-size: 0.95rem;">
            ${avatar}
          </div>
          <div style="min-width: 0; flex: 1;">
            <div style="font-weight: 800; color: #111827; font-size: 0.95rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              ${escapeHTML(displayName)}
            </div>
            <div class="text-muted" style="font-size: 0.82rem; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 0.1rem;">
              ${escapeHTML(m.invitedEmail)}
            </div>
          </div>
        </div>

        <div style="display: flex; align-items: center; gap: 0.5rem; flex-shrink: 0;">
          <span style="font-size: 0.75rem; padding: 0.25rem 0.65rem; border-radius: var(--radius-pill); font-weight: 800; text-transform: uppercase; ${isPending ? 'background: #FEF3C7; color: #B45309;' : 'background: #ECFDF5; color: #047857;'}">
            ${isPending ? 'Pendente' : m.role === 'admin' ? 'Administrador' : 'Membro'}
          </span>
          ${m.role !== 'admin' ? `
            <button class="btn-delete-member" data-id="${m.id}" data-name="${escapeHTML(displayName)}" title="Remover Membro" style="background: none; border: none; color: #94A3B8; cursor: pointer; padding: 0.35rem; display: flex; align-items: center; border-radius: 0.5rem;">
              <span class="material-symbols-outlined" style="font-size: 20px;">person_remove</span>
            </button>
          ` : ''}
        </div>
      </div>
    `;
  }).join('');

  contentEl.innerHTML = `
    <!-- Header Card -->
    <div class="chart-card mb-lg" style="padding: 1.5rem 1.5rem; margin-bottom: 1.25rem;">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div>
          <span class="text-muted" style="font-size: 0.75rem; text-transform: uppercase; font-weight: 800; letter-spacing: 0.05em;">Grupo Familiar</span>
          <h2 style="font-weight: 800; color: #111827; font-size: 1.45rem; margin: 0.2rem 0 0 0; line-height: 1.2;">${escapeHTML(family.name)}</h2>
        </div>
        <div style="background: #ECFDF5; color: #047857; border: 1px solid #A7F3D0; padding: 0.4rem 0.85rem; border-radius: var(--radius-pill); font-weight: 800; font-size: 0.85rem; display: flex; align-items: center; gap: 0.35rem;">
          <span class="material-symbols-outlined" style="font-size: 18px;">group</span>
          ${(family.members || []).length} Membro(s)
        </div>
      </div>
    </div>

    <!-- Invite Form -->
    <div class="chart-card mb-lg" style="padding: 1.5rem 1.5rem; margin-bottom: 1.25rem;">
      <h3 style="font-weight: 800; color: #111827; font-size: 1.15rem; margin: 0 0 0.75rem 0;">Convidar Membro da Família</h3>
      <form id="invite-member-form" style="display: flex; gap: 0.65rem; flex-wrap: wrap;">
        <input type="email" id="invite-email-input" placeholder="E-mail do familiar (ex: familiar@gmail.com)" required style="flex: 1; min-width: 180px; padding: 0.75rem 1rem; background: #FFFFFF; border: 1px solid var(--border-color); border-radius: 0.75rem; color: #111827; font-size: 0.9rem; outline: none;">
        <button type="submit" class="btn btn-primary" style="font-weight: 700; padding: 0.75rem 1.25rem; border-radius: var(--radius-pill); border: none; cursor: pointer; display: flex; align-items: center; gap: 0.4rem; font-size: 0.875rem; white-space: nowrap;">
          <span class="material-symbols-outlined" style="font-size: 18px;">person_add</span>
          Convidar
        </button>
      </form>
    </div>

    <!-- Members List -->
    <div class="chart-card" style="padding: 1.5rem 1.5rem; margin-bottom: 1.25rem;">
      <h3 style="font-weight: 800; color: #111827; font-size: 1.15rem; margin: 0 0 1rem 0;">Membros do Grupo</h3>
      <div style="display: flex; flex-direction: column; gap: 0.75rem;">
        ${membersHTML}
      </div>
    </div>

    <!-- Delete Family Group Action (Admin Only) -->
    <div style="margin-top: 1.5rem; text-align: center;">
      <button id="btn-delete-family-group" style="background: #FEF2F2; color: #DC2626; border: 1px solid #FECDD3; padding: 0.65rem 1.15rem; border-radius: var(--radius-pill); font-size: 0.82rem; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: 0.4rem; transition: all 150ms ease;">
        <span class="material-symbols-outlined" style="font-size: 18px;">delete_forever</span>
        Excluir Grupo Familiar
      </button>
      <p class="text-muted" style="margin: 0.4rem 0 0 0; font-size: 0.75rem;">
        Para excluir a família, é necessário remover todos os outros membros ativos primeiro.
      </p>
    </div>

    <!-- Custom Delete Family Modal -->
    <div id="delete-family-modal" class="modal-overlay hidden" style="position: fixed; inset: 0; background: rgba(0, 0, 0, 0.65); backdrop-filter: blur(8px); z-index: 9999; display: none !important; align-items: center; justify-content: center; padding: 1rem;">
      <div class="modal-card" style="background: var(--bg-surface); border-radius: 1.25rem; border: 1px solid var(--border-color); box-shadow: var(--shadow-card); max-width: 400px; width: 100%; padding: 1.75rem 1.5rem; text-align: center;">
        <div style="width: 52px; height: 52px; border-radius: 50%; background: var(--color-danger-bg); color: var(--color-danger); display: flex; align-items: center; justify-content: center; margin: 0 auto 1rem auto; border: 1px solid var(--color-danger-border);">
          <span class="material-symbols-outlined" style="font-size: 28px;">delete_forever</span>
        </div>
        <h3 style="font-weight: 800; font-size: 1.15rem; color: var(--text-main); margin: 0 0 0.4rem 0;">Excluir Grupo Familiar?</h3>
        <p class="text-muted" style="font-size: 0.85rem; line-height: 1.4; margin: 0 0 1.25rem 0;">
          Esta ação removerá permanentemente o grupo "${escapeHTML(family.name)}" e o acesso compartilhado dos membros.
        </p>
        <div style="display: flex; gap: 0.5rem;">
          <button class="btn btn-secondary" id="btn-cancel-delete-family" style="flex: 1; border-radius: var(--radius-pill); font-weight: 700;">
            Cancelar
          </button>
          <button class="btn btn-danger" id="btn-confirm-delete-family" style="flex: 1; border-radius: var(--radius-pill); font-weight: 700; background: #DC2626; color: #FFF;">
            Sim, Excluir
          </button>
        </div>
      </div>
    </div>

    <!-- Custom Delete Member Modal -->
    <div id="delete-member-modal" class="modal-overlay hidden" style="position: fixed; inset: 0; background: rgba(0, 0, 0, 0.65); backdrop-filter: blur(8px); z-index: 9999; display: none !important; align-items: center; justify-content: center; padding: 1rem;">
      <div class="modal-card" style="background: var(--bg-surface); border-radius: 1.25rem; border: 1px solid var(--border-color); box-shadow: var(--shadow-card); max-width: 400px; width: 100%; padding: 1.75rem 1.5rem; text-align: center;">
        <div style="width: 52px; height: 52px; border-radius: 50%; background: var(--color-danger-bg); color: var(--color-danger); display: flex; align-items: center; justify-content: center; margin: 0 auto 1rem auto; border: 1px solid var(--color-danger-border);">
          <span class="material-symbols-outlined" style="font-size: 28px;">person_remove</span>
        </div>
        <h3 style="font-weight: 800; font-size: 1.15rem; color: var(--text-main); margin: 0 0 0.4rem 0;">Remover Membro?</h3>
        <p class="text-muted" id="delete-member-modal-desc" style="font-size: 0.85rem; line-height: 1.4; margin: 0 0 1.25rem 0;">
          Deseja realmente remover este membro da família?
        </p>
        <div style="display: flex; gap: 0.5rem;">
          <button class="btn btn-secondary" id="btn-cancel-delete-member" style="flex: 1; border-radius: var(--radius-pill); font-weight: 700;">
            Cancelar
          </button>
          <button class="btn btn-danger" id="btn-confirm-delete-member" style="flex: 1; border-radius: var(--radius-pill); font-weight: 700; background: #DC2626; color: #FFF;">
            Sim, Remover
          </button>
        </div>
      </div>
    </div>
  `;

  // Bind invite form
  const inviteForm = contentEl.querySelector('#invite-member-form');
  if (inviteForm) {
    inviteForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = contentEl.querySelector('#invite-email-input');
      const email = input?.value?.trim();
      if (!email) return;

      try {
        const res = await authManager.fetchWithAuth('/api/family/members', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email })
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.error || 'Erro ao adicionar membro');
        }

        if (syncManager) syncManager.showToast('Convite enviado com sucesso!', 'success');
        await loadFamilyData(contentEl, syncManager);
      } catch (err) {
        if (syncManager) {
          syncManager.showToast(err.message, 'error');
        } else {
          console.error(err);
        }
      }
    });
  }

  // Bind delete family group modal
  const btnDeleteFamily = contentEl.querySelector('#btn-delete-family-group');
  const deleteFamilyModal = contentEl.querySelector('#delete-family-modal');
  const btnConfirmDeleteFamily = contentEl.querySelector('#btn-confirm-delete-family');
  const btnCancelDeleteFamily = contentEl.querySelector('#btn-cancel-delete-family');

  if (btnDeleteFamily && deleteFamilyModal) {
    btnDeleteFamily.addEventListener('click', (e) => {
      e.preventDefault();
      deleteFamilyModal.style.setProperty('display', 'flex', 'important');
      deleteFamilyModal.classList.remove('hidden');
    });

    btnCancelDeleteFamily?.addEventListener('click', () => {
      deleteFamilyModal.style.setProperty('display', 'none', 'important');
      deleteFamilyModal.classList.add('hidden');
    });

    btnConfirmDeleteFamily?.addEventListener('click', async () => {
      deleteFamilyModal.style.setProperty('display', 'none', 'important');
      deleteFamilyModal.classList.add('hidden');
      try {
        const res = await authManager.fetchWithAuth('/api/family', {
          method: 'DELETE'
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.error || 'Não foi possível excluir o grupo familiar');
        }

        if (syncManager) syncManager.showToast('Grupo familiar excluído com sucesso.', 'success');
        await loadFamilyData(contentEl, syncManager);
      } catch (err) {
        if (syncManager) {
          syncManager.showToast(err.message, 'error');
        } else {
          console.error(err);
        }
      }
    });
  }

  // Bind remove member modal
  const deleteMemberModal = contentEl.querySelector('#delete-member-modal');
  const deleteMemberDesc = contentEl.querySelector('#delete-member-modal-desc');
  const btnConfirmDeleteMember = contentEl.querySelector('#btn-confirm-delete-member');
  const btnCancelDeleteMember = contentEl.querySelector('#btn-cancel-delete-member');
  let selectedMemberIdToDelete = null;

  if (deleteMemberModal) {
    btnCancelDeleteMember?.addEventListener('click', () => {
      deleteMemberModal.style.setProperty('display', 'none', 'important');
      deleteMemberModal.classList.add('hidden');
      selectedMemberIdToDelete = null;
    });

    btnConfirmDeleteMember?.addEventListener('click', async () => {
      if (!selectedMemberIdToDelete) return;
      deleteMemberModal.style.setProperty('display', 'none', 'important');
      deleteMemberModal.classList.add('hidden');

      try {
        const res = await authManager.fetchWithAuth(`/api/family/members/${selectedMemberIdToDelete}`, {
          method: 'DELETE'
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.error || 'Falha ao remover membro');
        }

        if (syncManager) syncManager.showToast('Membro removido com sucesso.', 'success');
        await loadFamilyData(contentEl, syncManager);
      } catch (err) {
        if (syncManager) {
          syncManager.showToast(err.message, 'error');
        } else {
          console.error(err);
        }
      } finally {
        selectedMemberIdToDelete = null;
      }
    });

    contentEl.querySelectorAll('.btn-delete-member').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        selectedMemberIdToDelete = btn.getAttribute('data-id');
        const memberName = btn.getAttribute('data-name') || 'este membro';
        if (deleteMemberDesc) {
          deleteMemberDesc.textContent = `Deseja realmente remover ${memberName} do grupo familiar?`;
        }
        deleteMemberModal.style.setProperty('display', 'flex', 'important');
        deleteMemberModal.classList.remove('hidden');
      });
    });
  }
}
